import EditLimitPage from '../../../components/pages/mypages/wish_lists/EditLimitPage.vue'

export default {
  components: { EditLimitPage }
}
